<div class="outer-conatiner">
    <div class="inner-container">
<p *ngIf="isPasswordReset"><strong>Your verification link has expired, <a href='/'>Click Here</a> to verify your email again
   </strong></p>
   <p *ngIf="!isPasswordReset"><strong>Your verification link has expired, <a href='/sign-in'>Click Here</a> to verify your email again
   </strong></p>

    </div>
</div>